<div *ngFor="let error of errors$ | async;" class="ng-invalid" #container>
  {{error}}
</div>
